import { isAfter } from 'date-fns'
import { useCallback, useEffect, useRef, useState } from 'react'

import { CustomerTypeChangeModal } from '@/contentComponents/modal/CustomerTypeChangeModal'
import NoticeBoardModal from '@/contentComponents/modal/NoticeBoardModal/NoticeBoardModal.tsx'
import RequiredConfirmModal from '@/contentComponents/modal/RequiredConfirmModal/RequiredConfirmModal'
import { NoticeBoardColl } from '@/dto/Notice/NoticeBoard.ts'
import commonRepo from '@/repository/common.repo'
import { RouteName } from '@/router'
import modalService from '@/service/modal.service'
import popupService from '@/service/popup.service'
import { localStorageService } from '@/service/storage.service'
import { remoteStorageService } from '@/utils/axios/remoteStorage'
import { envUtils } from '@/utils/envUtils'

export const usePopup = (_off = false) => {
  const [off, setOff] = useState(!!_off)
  const dependencyItemsRef = useRef<string[]>([])

  const togglePopup = () => {
    setOff((prev) => {
      if (!envUtils.isLive) {
        localStorageService.setItem('POPUP_VISIBILITY_DEV_ONLY')(!prev)
      }
      if (!prev) {
        modalService.closeModal()
      }
      return !prev
    })
  }

  const handleNoticeBoardOpen = useCallback((notices: NoticeBoardColl) => {
    modalService.openModal(<NoticeBoardModal notices={notices} />, {
      hasCloseButton: false,
    })
  }, [])

  const handleCustomerTypeChangePopupOpen = useCallback(() => {
    modalService.openModal(<CustomerTypeChangeModal />, {
      hasCloseButton: false,
      isCloseable: false,
    })
  }, [])

  const fetchModals = useCallback(() => {
    if (commonRepo.user && commonRepo.academy) {
      if (commonRepo.academy.needCustomerTypeChange) {
        handleCustomerTypeChangePopupOpen()
        return
      }
      // 온보딩 팝업 리스트 전체 불러오기
      popupService.fetchAndSetOnboardingPopups(commonRepo.user.teacherId)

      // 팝업 보지 않기 기간 확인.
      const teacherId = commonRepo.user.teacherId
      const today = new Date()

      /**
       * @deprecated
       * 하위 호환성을 위한 코드
       * 2025-08-13 배포 이후 삭제 가능
       */
      const deprecated_doNotShowAgainNoticeModalExpireDate = localStorage.getItem(
        `DO_NOT_SHOW_AGAIN_NOTICE_BOARD_DATE_${teacherId}`,
      )
        ? new Date(localStorage.getItem(`DO_NOT_SHOW_AGAIN_NOTICE_BOARD_DATE_${teacherId}`)!)
        : null

      const doNotShowAgainNotice = localStorageService.getItem(
        `PERSIST_DO_NOT_SHOW_AGAIN_NOTICE_BOARD_${teacherId}`,
      )

      const showDoNotShowAgainNotice =
        doNotShowAgainNotice?.teacherId === teacherId && doNotShowAgainNotice
          ? isAfter(today, new Date(doNotShowAgainNotice.expiredAt))
          : true

      if (showDoNotShowAgainNotice) {
        localStorageService.removeItem(`PERSIST_DO_NOT_SHOW_AGAIN_NOTICE_BOARD_${teacherId}`)
      }

      const showNoticeBoard = deprecated_doNotShowAgainNoticeModalExpireDate
        ? isAfter(today, deprecated_doNotShowAgainNoticeModalExpireDate)
        : showDoNotShowAgainNotice

      // 팝업 띄우기
      popupService
        .getFirstCommonPopup(
          commonRepo.user.teacherId,
          commonRepo.academy?.status,
          commonRepo.academy.authority,
          'B2B',
        )
        .then((popups) => {
          if (!popups) {
            return
          }
          const dependency = {
            pathname: window.location.pathname,
            off,
            user: commonRepo.user,
            academy: commonRepo.academy,
            timestamp: Date.now(),
          }

          dependencyItemsRef.current.push(JSON.stringify(dependency))

          if (dependencyItemsRef.current.length >= 1) {
            if (dependencyItemsRef.current.length === 1) {
              // 정상적인 케이스
              if (!showNoticeBoard || popups.length === 0) return
              handleNoticeBoardOpen(new NoticeBoardColl(popups))
            }
          }
        })
        .catch((e) => {
          console.error(e)
          //toast는 의도적으로 띄우지 않는다.
        })
    }
  }, [
    off,
    handleCustomerTypeChangePopupOpen,
    handleNoticeBoardOpen,
    commonRepo.academy,
    commonRepo.user,
  ])

  useEffect(() => {
    if (!envUtils.isLive && off) return
    if (commonRepo.isLimited) return
    const pathname = window.location.pathname

    // 서버 점검중이거나 tally 임베드 페이지일땐 띄우지 않기
    if (pathname === RouteName.serverMaintenance) return
    if (pathname === RouteName.tallyEmbed) return
    if (!commonRepo.user || !commonRepo.academy) {
      dependencyItemsRef.current = []
      return
    }

    fetchModals()

    // TODO: ScienceFlat
    // remoteStorageService
    //   .get('STARTED_NEW_DESIGN_FLAT')
    //   .then((response) => {
    //     if (!response) {
    //       modalService.openModal(<RequiredConfirmModal />, {
    //         hasCloseButton: false,
    //         isCloseable: false,
    //         modalStyle: {
    //           content: {
    //             backgroundColor: 'transparent',
    //           },
    //         },
    //       })

    //       return
    //     }
    //   })
    //   .finally(() => {
    //     fetchModals()
    //   })
  }, [off, fetchModals])

  return { off, togglePopup }
}
